// test1691
(1691 && 0);
